import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Scorecard from './Scorecard'

const loadCourse = (id) => ({
  type: 'LOAD_COURSE',
  payload: {
    request: {
      url: `/v3/layout/${id}`,
    },
  },
})

function PrintableScorecard({ course }) {
  const params = useParams()
  const dispatch = useDispatch()

  const { courseId } = params
  useEffect(() => {
    dispatch(loadCourse(courseId))
  }, [courseId, dispatch])

  const courseData = course.data
  if (courseData) {
    return (
      <div className="printable-scorecard">
        <Scorecard course={courseData} />
      </div>
    )
  }

  return <h1>Loading course...</h1>
}

const mapStateToProps = (state) => {
  return {
    course: state.course,
  }
}

export default connect(mapStateToProps)(PrintableScorecard)
